import { Component, OnInit, Input } from '@angular/core';
import { Schedule } from '../../models/schedule';
import { LocalizationService } from '../../../../services/localization.service';
import { DayScheduleInfo } from '../../models/day-schedule-info';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit {

  @Input()
  schedule: Schedule;

  constructor(
    private localizationService: LocalizationService,
  ) { }

  ngOnInit(): void {
  }

  get scheduleCaption(): string {
    return this.schedule && this.schedule.caption ? this.schedule.caption : '';
  }

  get startDate(): string {
    return this.schedule && this.schedule.startDate ? this.localizationService.formatDate(this.schedule.startDate) : '';
  }

  get scheduleDate(): string {
    const startDate = this.schedule && this.schedule.startDate ? this.schedule.startDate : null;
    const endDate = this.schedule && this.schedule.endDate ? this.schedule.endDate : null;
    return this.formatDatesRange(startDate, endDate);
  }

  formatDatesRange(startDate: Date, endDate: Date): string {
    let scheduleDate = '';
    if (startDate) {
      scheduleDate = this.localizationService.formatDate(startDate);
      if (endDate) {
        if (endDate.getTime() !== startDate.getTime()) {
          scheduleDate = scheduleDate + '-' + this.localizationService.formatDate(endDate);
        }
      } else {
        scheduleDate = scheduleDate + '- ...';
      }
    }

    return scheduleDate;
  }

  formatDatesRangeFromDatesArray(datesRangeArray: Array<any>): string {
    let scheduleDate = '';

    if (!datesRangeArray || datesRangeArray.length !== 2) {
      return scheduleDate;
    }
    const startDate = datesRangeArray[0] ? new Date(datesRangeArray[0]) : null;
    const endDate = datesRangeArray[1] ? new Date(datesRangeArray[1]) : null;
    scheduleDate = this.formatDatesRange(startDate, endDate);

    return scheduleDate;
  }

  get scheduleGrouppedDays(): DayScheduleInfo[] {
    return this.schedule && this.schedule.dayScheduleInfoGroupped && this.schedule.dayScheduleInfoGroupped.length > 0 ? this.schedule.dayScheduleInfoGroupped : [];
  }

  getShortWeekDayRangeName(dayRange: string): string {
    let formattedDayRange = '';

    if (!dayRange) {
      return formattedDayRange;
    }

    const splitDayRange = dayRange.split('-');
    if (splitDayRange.length === 1) {
      formattedDayRange = this.localizationService.getWeekdayNameShortByIndex(parseInt(splitDayRange[0], 10));
    } else if (splitDayRange.length === 2) {
      formattedDayRange = this.localizationService.getWeekdayNameShortByIndex(parseInt(splitDayRange[0], 10)) + ' - ' + this.localizationService.getWeekdayNameShortByIndex(parseInt(splitDayRange[1], 10));
    }

    return formattedDayRange;
  }

  getTimeRange(workingTime: Array<number>): string {
    let timeRange = '';

    if (!workingTime || workingTime.length !== 2) {
      return timeRange;
    }

    timeRange = environment.globalSettings.toTimeString(workingTime[0]) + '-' + environment.globalSettings.toTimeString(workingTime[1]);
    return timeRange;
  }

  get additionalDates(): string[] {
    return this.schedule && this.schedule.additionalDates ?
      this.schedule.additionalDates
        .map(item => this.formatDatesRangeFromDatesArray(item))
        .filter(item => item !== this.scheduleDate)
      : [];
  }
}
